var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"js-video [vimeo, widescreen]",style:(_vm.frameStyle)},[_c('iframe',{attrs:{"src":_vm.getVideoURL(),"frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":function($event){return _vm.close()}}},[_c('span',[_vm._v("< Back")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67edc1c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VideoIframe/index.vue
// module id = null
// module chunks = 